import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthActions } from '@shared/store/auth/auth.actions';
import { ApplicationModel } from 'app/model/application.model';
import { BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ApplicationFacadeService } from '@shared/service/application-facade.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private collapseMenuBreakpoint: number = 1440;

  public menuCollapse: boolean = window.innerWidth < this.collapseMenuBreakpoint;

  private subscription: Subscription = new Subscription();
  public sideMenuVisible: boolean = true;

  @HostListener('click', [ '$event' ])
  public hostClicked(): void {
    this.applicationFacadeService.mainLayoutClicked$.emit();
  }

  constructor(private applicationModel: ApplicationModel,
              private store: Store,
              private router: Router,
              private modalService: BsModalService,
              private applicationFacadeService: ApplicationFacadeService) {
    this.subscribeWindowSize();
    this.subscribeRouterEvents();
    this.subscribeSideMenuVisibility()
  }

  ngOnInit(): void {
    this.store.dispatch(AuthActions.GetCurrentLogged);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // controls menu collapse depending on window width
  private subscribeWindowSize(): void {
    this.subscription.add(
      this.applicationModel.windowSize$
        .pipe(
          map((windowSize) => windowSize < this.collapseMenuBreakpoint ? true : false),
          distinctUntilChanged()
        ).subscribe(
        (value: boolean) => {
          this.menuCollapse = value;
        }
      )
    );
  }

  // manage closing mobile menu when redirect
  private subscribeRouterEvents(): void {
    this.subscription.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart)
      ).subscribe(() => {
        this.menuCollapse = window.innerWidth < this.collapseMenuBreakpoint ? true : false;
      })
    );
  }

  private subscribeSideMenuVisibility(): void {
    this.subscription.add(this.applicationModel.sideMenuVisible$
      .pipe(
        debounceTime(10)
      )
      .subscribe((visible: boolean) => {
        this.sideMenuVisible = visible;
      }));
  }

}
